
<div class="premium_label">
    <b-icon-star-fill></b-icon-star-fill>&nbsp;{{ $t("premium") }}
</div>
